import React from 'react';
import { Tag } from 'antd';
import styled from 'styled-components';
import {
  SupraCoopType,
  supraCoopTypeToLabelMap,
} from '@bb/domain/dist/types/SupraSystemSubscription';

type SupraCoopTypeProps = {
  coopType?: SupraCoopType;
};

const SupraCoopTypeTag: React.FC<SupraCoopTypeProps> = ({
  coopType = SupraCoopType.PRIMARY,
}) => {
  const colorMap: Record<SupraCoopType, string | undefined> = {
    AUTO_COOP: 'pink',
    MANUAL_COOP: 'cyan',
    PRIMARY: 'blue',
  };

  return (
    <StyledTag color={colorMap[coopType]}>
      {supraCoopTypeToLabelMap[coopType]}
    </StyledTag>
  );
};

const StyledTag = styled(Tag)`
  font-weight: 400;
`;

export default SupraCoopTypeTag;
